import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-500b635d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iframe" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconClose = _resolveComponent("IconClose")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.currentIframeTitle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["file-upload__header page-header", {'sl-full': _ctx.isFullScreen}])
        }, [
          _createElementVNode("a", {
            href: "javascript:;",
            class: "qh-icon-back",
            title: "返回",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
          }),
          _createElementVNode("h1", null, _toDisplayString(_ctx.currentIframeTitle), 1),
          (_ctx.currentIframeShowClose)
            ? (_openBlock(), _createBlock(_component_IconClose, {
                key: 0,
                onClick: _ctx.handleClose
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("iframe", {
      id: "plugin_loader",
      class: _normalizeClass([{'show-full': !_ctx.currentIframeTitle && _ctx.isFullScreen, 'show-title-full': _ctx.currentIframeTitle && _ctx.isFullScreen,'show-title': _ctx.currentIframeTitle && !_ctx.isFullScreen}, "current-plugin-iframe"]),
      src: _ctx.currentIframeUrl,
      frameborder: "0",
      name: "plugin_loader"
    }, null, 10, _hoisted_2)
  ]))
}